// 图片元素的覆层组件
import React from 'react';
import { getWrappedOverlayer } from '@starflow/app/extension';
import { ImageInnerTools, ImageFeedback, ImageSubTools } from './legacy';
import { useTempState } from '@starflow/app/store';

const SubTools = ({ element }) => {
  return (
    <div className="absolute -inset-px z-[1]">
      <ImageInnerTools element={element} />
      <ImageFeedback element={element} />
    </div>
  );
};

export const ImageOverlayerInner = (props) => {
  const { element, outerClassName, innerClassName, isMiniMode, toolbar, isExactlySelected } = props;

  return (
    <>
      {!isMiniMode && <SubTools element={element} />}
      {isExactlySelected && (
        <div className={`${outerClassName || ''} absolute z-[2] top-full left-1/2 -translate-x-1/2 pt-2`}>
          <div className={`${innerClassName || ''} pointer-events-auto`}>
            {toolbar || <ImageSubTools element={element} />}
          </div>
        </div>
      )}
    </>
  );
};

export const ImageOverlayer = React.memo((props) => {
  const { isExactlySelected, isHovering, isMiniMode } = props;
  const isMaskExist = useTempState('isMaskExist');

  const WrapperOverLayer = getWrappedOverlayer('image', ImageOverlayerInner);

  if (!isMaskExist) return null;

  return (
    <WrapperOverLayer
      {...props}
      isMiniMode={isMiniMode}
      isHovering={isHovering}
      isExactlySelected={isExactlySelected}
    />
  );
});
